<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

        <CounterpartyEditComponent/>

    </transition>
  </div>
</template>

<script>

import CounterpartyEditComponent from '@/components/counterparties/CounterpartyEditComponent.vue'

export default {
  name: 'CounterpartyEdit',
  components: {
    CounterpartyEditComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>
